module.exports = __webpack_public_path__ + "front/img/btn_content.f713c036.png";